import type { OutcomeParameterValue } from '../../../types';

export const getMiddleNumericFilterValue = (
    values: OutcomeParameterValue[],
): OutcomeParameterValue => {
    return values[Math.floor(values.length / 2)];
}
